import { render, staticRenderFns } from "./BEN.vue?vue&type=template&id=d75e24b8&scoped=true&"
import script from "./BEN.vue?vue&type=script&lang=js&"
export * from "./BEN.vue?vue&type=script&lang=js&"
import style0 from "./BEN.vue?vue&type=style&index=0&id=d75e24b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d75e24b8",
  null
  
)

export default component.exports